<template>
    <div
        class="mvt-dropdown"
        :class="[{'mvt-dropdown--open':active, 'mvt-dropdown--disabled':disabled, 'mvt-dropdown--resettable': resettable}, size ? `mvt-dropdown--size-${size}` : '']"
    >
      <button
          v-ga:click="{ action: 'dropdown-open' }"
          :class="[btnClass, { active: active || resettable }, size ?? '']"
          :style="{ textAlign }"
          @click="toggle"
      >
        <span>
          <i v-if="labelIcon" :class="labelIcon"></i>
          <span v-html="labelText"></span>
        </span>
        <i v-if="resettable" class="mvt-dropdown__close icon-times" @click.stop="reset"></i>
        <i v-else class="icon-angle-down"></i>
      </button>
      <ul class="mvt-dropdown__items">
        <li v-for="(item, i) in filteredItems" :key="i" class="mvt-dropdown__item">
          <a :href="item.href || '#'" :role="item.href ? null : 'button'" @click="(e) => onSelect(e, item)">
            <i v-if="item.icon" :class="item.icon" ></i>
            <span>{{ item.text }}</span>
          </a>
        </li>
      </ul>
    </div>
</template>
<script src="./mvt-dropdownlist.js"></script>
<style lang="scss">
@use "./mvt-dropdownlist" as *;
</style>
